export default "__VITE_ASSET__BMGyKRqr__"